{
    "form_error_required": "Champ obligatoire",
    "sales_draft__list_view__header__customer": "Client",
    "sales_draft__list_view__header__creation_date": "Date de création",
    "sales_draft__list_view__header__total": "Total",
    "sales_draft__list_view__header__positions": "Lignes",
    "sales_draft__list_view__header__created_by": "Créé par",
    "sales_draft__list_view__action__edit": "Modifier",
    "sales_draft__list_view__action__delete": "Supprimer",
    "sales_draft__list_view__filter_customers": "Clients",
    "sales_draft__list_view__filter_users": "Créé par",
    "sales_draft__list_view__filter_states": "Statut",
    "sales_draft__list_view__search_placeholder": "Rechercher un client",
    "sales_draft__header__sub_title__order": "Nouvelle commande",
    "sales_draft__header__sub_title__quote": "Nouveau devis",
    "sales_draft__button_group__search_catalog": "Catalogue",
    "sales_draft__stepper__line_items": "Lignes",
    "sales_draft__stepper__header": "En-tête",
    "sales_draft__summary__overview": "Aperçu",
    "sales_draft__summary__number_of_positions": "Nombre de lignes",
    "sales_draft__summary__contribution_margin_percent": "Marge brute %",
    "sales_draft__summary__contribution_margin": "Marge brute",
    "sales_draft__summary__total_position": "Total des lignes",
    "sales_draft__button_group__continue": "Continuer vers l'en-tête",
    "sales_draft__button_group__cancel": "Annuler",
    "sales_draft__line_items__table_header__article": "Article",
    "sales_draft__line_items__table_header__quantity": "Quantité",
    "sales_draft__line_items__table_header__price": "Prix",
    "sales_draft__line_items__table_header__rebate": "Remise",
    "sales_draft__line_items__table_header__gross_margin_percent": "Marge %",
    "sales_draft__edit__line_item": "Modifier en détail",
    "sales_draft__delete__line_item": "Supprimer",
    "sales_draft__item_form__quantity": "Quantité",
    "sales_draft__item_form__price": "Prix",
    "sales_draft__item_form__rebate": "Remise",
    "sales_draft__item_form__gross_margin_percent": "Marge brute %",
    "sales_draft__item_form__gross_margin": "Marge brute",
    "sales_draft__item_form__total": "Total",
    "sales_draft__item_form__storage": "Entrepôt",
    "sales_draft__item_form__storage_from_header": "Depuis l'en-tête ({{id}} : {{name}})",
    "sales_draft__item_form__shipping_type_id": "Mode d'expédition",
    "sales_draft__item_form__note": "Note de ligne",
    "sales_draft__item_form__encoded_price": "Code marchandise",
    "sales_draft__cancel_confirmation_dialog__title": "Annuler et supprimer la transaction ?",
    "sales_draft__cancel_confirmation_dialog__description": "La transaction n'est pas enregistrée. Cette action est irréversible.",
    "sales_draft__cancel_confirmation_dialog__accept": "Supprimer la transaction",
    "sales_draft__cancel_confirmation_dialog__reject": "Continuer la modification",
    "sales_draft__delete_success_toast__title": "Brouillon supprimé",
    "sales_draft__delete_success_toast__description": "Vous pouvez <linkTag>créer une nouvelle transaction</linkTag> ici",
    "sales_draft__button_group__back_to_line_items": "Retour",
    "sales_draft__button_group__submit": "Enregistrer dans le système ERP",
    "sales_draft__header__billing_address": "Adresse de facturation",
    "sales_draft__header__shipping_address": "Sélectionner l'adresse de livraison",
    "sales_draft__header__contact_person": "Personne de contact",
    "sales_draft__header__contact_person__select": "Sélectionner une personne de contact",
    "sales_draft__header__delivery_date": "Date souhaitée",
    "sales_draft__header__order_type": "Type de commande",
    "sales_draft__header__order_type__select": "Sélectionner le type de commande",
    "sales_draft__header__shipping_type": "Mode d'expédition par défaut",
    "sales_draft__header__shipping_type__select": "Sélectionner le mode d'expédition",
    "sales_draft__header__commission": "N° de commande client",
    "sales_draft__header__notes": "Texte d'en-tête",
    "sales_draft__header__notes_placeholder": "Ajouter une note destinée au client, affichée sur les documents PDF",
    "sales_draft__header__due_date": "Valable jusqu'au",
    "sales_draft__header__quote_type": "Type de devis",
    "sales_draft__header__quote_type__select": "Sélectionner le type de devis",
    "sales_draft__header__submit_error": "Erreur lors de l'enregistrement dans le système ERP",
    "sales_draft__ORDER__submit_confirmation_dialog__title": "Enregistrer la commande dans le système ERP ?",
    "sales_draft__ORDER__submit_confirmation_dialog__description": "La commande est enregistrée dans le système ERP et ne peut plus être modifiée dans Plato.",
    "sales_draft__ORDER__submit_success_toast__title": "Commande enregistrée dans le système ERP",
    "sales_draft__ORDER__submit_success_toast__description": "Elle sera bientôt visible par tous dans le système ERP",
    "sales_draft__QUOTE__submit_confirmation_dialog__title": "Enregistrer le devis dans le système ERP ?",
    "sales_draft__QUOTE__submit_confirmation_dialog__description": "Le devis est enregistré dans le système ERP et ne peut plus être modifié dans Plato.",
    "sales_draft__QUOTE__submit_success_toast__title": "Devis enregistré dans le système ERP",
    "sales_draft__QUOTE__submit_success_toast__description": "Il sera bientôt visible par tous dans le système ERP",
    "sales_draft__submit_confirmation_dialog__accept": "Confirmer",
    "sales_draft__submit_confirmation_dialog__reject": "Continuer la modification",
    "sales_draft__delete_confirmation_dialog__title": "Supprimer ce brouillon ?",
    "sales_draft__delete_confirmation_dialog__description": "Le brouillon sera définitivement supprimé. Cette action est irréversible.",
    "sales_draft__submit_error_toast__title": "Erreur lors de l'enregistrement dans le système ERP",
    "sales_draft__submit_error_toast__description": "Le brouillon n'a pas pu être enregistré. Veuillez réessayer.",
    "sales_draft__update_error_toast__title": "Erreur lors de l'enregistrement du brouillon",
    "sales_draft__update_error_toast__description": "Le brouillon n'a pas pu être enregistré. Veuillez réessayer.",
    "sales_draft__quick_filters__by_me": "Mes brouillons",
    "sales_draft__quick_filters__submitted": "Récemment transmis à l'ERP",
    "sales_draft__list_view__action__view": "Voir la transaction",
    "sales_draft__status__NEW": "Brouillon",
    "sales_draft__status__SUBMITTED": "Transmis",
    "sales_draft__recommended_header": "Produits recommandés",
    "sales_draft__recommended_header__customer": "Produits phares de ce client",
    "sales_draft__recommended_header__tenant": "Produits les plus vendus",
    "sales_draft__recommended_loading": "Chargement",
    "sales_draft__recommended_none": "Aucun autre produit recommandé",
    "sales_draft__related_items_header": "Articles similaires",
    "sales_draft__incremental_quantity_dialog__title": "L'unité de conditionnement ne peut pas être fractionnée",
    "sales_draft__incremental_quantity_dialog__description": "Sélectionner un multiple de l'unité de conditionnement",
    "sales_draft__incremental_quantity_dialog__confirm": "Ajouter",
    "sales_draft__error_no_unit": "Aucune unité de vente trouvée",
    "sales_draft__error_stock": "Erreur lors de la consultation du stock"
}
